import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProdutoOutput } from 'src/app/@shared/models/produto.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ProdutoService {

  constructor(private http: HttpClient) { }


  selecionarProdutos(clienteId): Observable<any[]> {
    return this.http.get<any[]>(`PedidoNRT/SelecionarProdutos/${clienteId}`, httpOptions);
  }
  selecionarProdutosEntrega(clienteId): Observable<any[]> {
    return this.http.get<any[]>(`PedidoNRT/SelecionarProdutosEntrega/${clienteId}`, httpOptions);
  }
  selecionarProdutosEntregaB2B(clienteId): Observable<any[]> {
    return this.http.get<any[]>(`PedidoNRT/SelecionarProdutosEntregaB2B/${clienteId}`, httpOptions);
  }

}
